var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-button-enterbirthday btn btn-primary",class:_vm.className},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.language.button_enterbirthday)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }